<template>
     <v-content>
        <v-app>
            <v-container grid-list-xl text-xs-center fluid class="container-transactions-volume">
                <v-layout wrap align-center>
                    <v-flex xs4 sm4 d-flex>
                        <v-select v-model="channel" :items="merchant" @change="getReport()" item-text="name" item-value="uuid" label="Companies"></v-select>
                    </v-flex>
                    <v-flex xs2>
                        <v-select v-model="dropDown.paid" dense :items="paidOptions" label="Paid" append-icon="search" @change="getReport()"></v-select>
                    </v-flex>
                    <v-flex xs2>
                        <v-select v-model="dropDown.linkClicked" dense :items="linkClickedOptions" label="Link Clicked" append-icon="search" @change="getReport()"></v-select>
                    </v-flex>
                </v-layout>

                 <v-layout row wrap align-center>
                    <v-flex xs12>
                        <v-data-table class="elevation-1 sms-report" :headers="tableHeaders" :items="report" item-key="id" :expand="expand" :loading="loading" :rows-per-page-items="rowsPerPage">
                            <template v-slot:items="props">
                                <tr @click="props.expanded = !props.expanded">
                                    <td class="text-xs-left font-weight-bold" :style="{color:'rgba(0,0,0,.54)'}">{{ props.item.createdAt }}</td>
                                    <td class="text-xs-left">{{ props.item.message }} </td>
                                    <td class="text-xs-left">{{ props.item.firstName }}</td>
                                    <td class="text-xs-left">{{ props.item.surname }}</td>
                                    <td class="text-xs-left">{{ props.item.merchantTransactionId }}</td>
                                    <td class="text-xs-left">{{ props.item.mobile }}</td>
                                    <td class="text-xs-left">{{ new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(props.item.amount) }}</td>
                                    <td class="text-xs-center">{{ props.item.linkClicked }}</td>
                                    <td v-if="props.item.resultCode == '000.000.000'" class="justify-center layout px-0 status-column">
                                        <v-icon small class="mr-2 vertical-align-middle" color="green">
                                            done
                                        </v-icon>
                                    </td>
                                    <td v-else-if="props.item.resultCode == null" class="justify-center layout px-0 status-column">
                                        <v-icon small class="mr-2 vertical-align-middle" color="blue">
                                            history
                                        </v-icon>
                                    </td>
                                    <td v-else class="justify-center layout px-0 status-column">
                                        <v-icon small class="mr-2 vertical-align-middle" color="red">
                                            clear
                                        </v-icon>
                                    </td>
                                </tr>
                            </template>
                            <template v-slot:expand="props">
                                <v-card class="" flat color="#ECEFF1">
                                    <v-card-title>
                                        <v-layout row wrap>
                                            <v-flex xs2 class="text-xs-left"><b>Processing Time:</b><span class="expanded ml-2">{{ props.item.processingTime }}</span></v-flex>
                                            <v-flex xs3 class="text-xs-left"><b>Result Code:</b><span class="expanded ml-2">{{ props.item.resultCode }} - {{ props.item.description }}</span></v-flex>
                                            <v-flex xs2 class="text-xs-left"><b>Bank:</b><span class="expanded ml-2">{{ props.item.bank }}</span></v-flex>
                                            <v-flex xs2 class="text-xs-left"><b>Payment Brand:</b><span class="expanded ml-2">{{ props.item.paymentBrand }}</span></v-flex>
                                            <v-flex xs2 class="text-xs-left"><b>Processing Time:</b><span class="expanded ml-2">{{ props.item.processingTime }}</span></v-flex>
                                        </v-layout>
                                    </v-card-title>
                                </v-card>
                            </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-app>
     </v-content>
</template>

<script>
import axios from 'axios';

export default {
        data() {
            return {
                loading: true,
                report: [],
                rowsPerPage:[10, 25, 50, 100],
                tableHeaders: [{ text: 'Date', value: 'createdAt', sortable: false },
                               { text: 'Message', value: 'message', sortable: false },
                               { text: 'First Name', value: 'firstName', sortable: false },
                               { text: 'Surname', value: 'surname', sortable: false },
                               { text: 'Reference', value: 'merchantTransactionId', sortable: false },
                               { text: 'Mobile', value: 'mobile', sortable: false },
                               { text: 'Amount', value: 'amount', sortable: false },
                               { text: 'Link Clicks', value: 'linkClicked', sortable: false },
                               { text: 'Paid', value: 'resultCode', sortable: false, align: 'center' }],
                download: false,
                channel: null,
                merchant: [],
                channelId: null,
                userId: localStorage.user_id,
                merchant: [{ uuid: '8ac9a4c76c110227016c2408bfad64b2', name: 'Bridgewater Support Solutions L' },
                           { uuid: '8acda4cd6bfee88f016bff7b3f970a6c', name: 'Financial Support Systems Ltd' }],
                expand: true,
                dropDown: { paid: null, linkClicked: null },
                paidOptions: [{ text: 'All', value: null },
                              { text: 'Successful', value: 1 }, 
                              { text: 'Pending', value: 2 },
                              { text: 'Failed', value: 0 }],
                linkClickedOptions: [{ text: 'All', value: null },
                                     { text: 'Yes', value: 1 }, 
                                     { text: 'No', value: 0 }]
            }
        },
        beforeMount() {
            this.getReport();
            this.channel = this.merchant[0];
        },
        methods: {
            getReport() {
                this.loading = true;
                this.channel = typeof(this.channel) === 'object' ? this.merchant[0].uuid : this.channel;

                axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/bridgewater-get-sms-report',
                data: { channelUuid: this.channel, paid: this.dropDown.paid, linkClicked: this.dropDown.linkClicked },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.loading = false;
                    this.report = response.data;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            },
            downloadReport() {
                axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/get-transactions-volume-pdf',
                data: { fromDate: this.dates.fromDate, toDate: this.dates.toDate },
                responseType: 'blob',
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'transactions-volume-report.csv');
                    document.body.appendChild(link);
                    link.click();
                    this.download = false;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            },
        }
}
</script>

<style>
.downloadBtn, .downloadProgress {
    width: 36px !important;
    height: 36px !important;
    margin-top: 0px !important;
}

</style>
